// extracted by mini-css-extract-plugin
export default {"nav":"DashboardTopBarAdmin_nav__kugdH","icon":"DashboardTopBarAdmin_icon__EbBHE"};